import { Box, FormControl, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import type { Entity } from '@src/Objects/Entity';
import React from 'react';

import type { EViewType } from './EntitiesPage';

export interface IViewType<T extends Entity> {
    id: EViewType;
    title: string;
    icon: JSX.Element;
    minWidth?: number;
    renderContainer: (
        allEntities: T[],
        visibleEntities: T[],
        width: number,
        selected: number[],
        tableSettings?: any,
    ) => JSX.Element;
    // renderEntity: <T extends Entity>(entity: T) => JSX.Element;
}
interface ViewTypeMenuProps<T extends Entity> {
    types: IViewType<T>[];
    selected: IViewType<T>;
    onChange: (type: IViewType<T>) => void;
}
export function ViewTypeMenu<T extends Entity>(props: ViewTypeMenuProps<T>) {
    const handleChange = (event: SelectChangeEvent<string>) => {
        const selectedType = props.types.find((type) => type.id === event.target.value);
        if (selectedType) {
            props.onChange(selectedType);
        }
    };

    if (!props.types.length) return <></>;

    return (
        <Box sx={{ minWidth: 120, mt: 1 }}>
            <FormControl size="small" variant="outlined" fullWidth>
                <Select
                    value={props.selected.id}
                    onChange={handleChange}
                    displayEmpty
                    sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'divider',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'primary.main',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'primary.main',
                        },
                    }}
                    renderValue={(value) => {
                        const type = props.types.find((t) => t.id === value);
                        return (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {type?.icon}
                                {type?.title}
                            </Box>
                        );
                    }}
                >
                    {props.types.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {type.icon}
                                {type.title}
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
